// SwmmRun.js
import { useEffect } from "react"
import createModule from '@fileops/swmm-wasm-web'
import { SwmmConvert, SwmmOut } from "@fileops/swmm-node"

/**
 * 
 * 
 * @param {JSON} model the swmm model in JSON format
 * @param {function} setSwmmOut sets the swmm .out file contents
 * @param {function} setRpt sets the .rpt file contents in string format
 * @param {function} setSwmmTxt sets the swmm model .inp file contents in string format
 * @param {number} modelRun state variable for the model run, on increment signals the component to run the epa-swmm executable on the model.
 * @param {function} setRunSpinner runs a spinner/display component for showing the progress of the executable.
 * @param {function} setOpenRptText sets a flag that will display the rpt contents when a model run is complete.
 * @returns hook for running a model when the modelRun variable changes
 */
function SwmmRun({model, setSwmmOut, setRpt, setSwmmTxt, modelRun, setRunSpinner, setOpenRptText}) {

  async function wrapSwmmRun(Module){
    let rpt = ''
    try
    {
      setRpt(rpt)
      Module.FS_createPath('/', '/', true, true)
      Module.FS_ignorePermissions = true
      let swmmTxt = SwmmConvert.dataToInpString(model)
      setSwmmTxt(swmmTxt)
      Module.FS_createDataFile('/', 'input.inp', swmmTxt, true, true)
  
      const f = async function (){
        const swmm_run = Module.cwrap('swmm_run', 'number', ['string', 'string', 'string'])
        swmm_run("/input.inp", "data/rpt.rpt", "data/out.out")
        return 1
      }
  
      f().then(function (){
        // Show the report as part of the output, if necessary
        rpt = intArrayToString(Module.FS.findObject('data/rpt.rpt').contents)
        setRpt(rpt)
  
        // Get the output from the wasm processor.
        let file = Module.FS.readFile('data/out.out').buffer
        setSwmmOut(new SwmmOut(file))
        // If there is no .out file resulting from the wasm processor, return empty.
        if (!file) return
        
        setRunSpinner(false)
        return rpt
      })
    } catch (e) {
      setRunSpinner(false)
      console.log('Model processing failed')
      console.log(e)
    } finally{
      setRunSpinner(false)
      setOpenRptText(true)
    }
  }

  useEffect(() => {
    if(model && Object.keys(model).length > 0 && modelRun !== 0){
      setRunSpinner(true)
      createModule().then((Module) => {
        wrapSwmmRun(Module)
      })
    }
  },[modelRun])

  return (null)
}

// old wasm assist
function intArrayToString(array) {
  var ret = []
  for (var i = 0; i < array.length; i++) {
    var chr = array[i]
    if (chr > 0xFF) {
      chr &= 0xFF
    }
    ret.push(String.fromCharCode(chr))
  }
  return ret.join('')
}

export {SwmmRun}